import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import Header from "../../../components/Layout/Header/Header";
import Footer from "../../../components/Layout/Footer/Footer";
import ScrollToTop from "../../../components/Common/ScrollTop";
import OffWrap from "../../../components/Layout/Header/OffWrap";
import SiteBreadcrumb from "../../../components/Common/Breadcumb";
import SearchModal from "../../../components/Layout/Header/SearchModal";
// Image
import footerLogo from "../../../assets/img/logo/lite-logo.png";

import QuickLinks from "../../../components/Common/QuickLinks";
import { BlocksRenderer } from "../../../components/BlockRenderer";
import { fetchData } from "../../../utils/fetchData";
import {
  getAPIPath,
  getMenu,
  getPageTitle,
} from "../../../utils/getDomainData";
const ProjectOpportunities = () => {
  const [data, setData] = useState([]);
  useEffect(() => {
    fetchData(getAPIPath()?.project_opportunities, setData);
  }, []);
  return (
    <React.Fragment>
      <Helmet>
        <title>Project opportunities – {getPageTitle()}</title>
        <meta name="description" content="" />
        <meta name="keywords" content=""></meta>
      </Helmet>
      <OffWrap />
      <Header
        parentMenu="home"
        TopBar="enable"
        TopBarClass="topbar-area dark-primary-bg hidden-lg"
      />
      <div className="pageTopOffset">
        <SiteBreadcrumb
          pageTitle="Project Opportunities"
          pageName="Project Opportunities"
          breadcrumbsClass="breadcrumb-bg"
        />
        {getMenu()}
        <div id="rs-about" className="rs-about style3 pt-50 pb-50 md-pt-30">
          <div className="container">
            <div className="row">
              <div className="col-lg-9 md-mb-30">
                <div className="content-wrapper">
                  <div className="content-section">
                    <h3 style={{ marginBottom: "20px" }} title={data?.data?.attributes?.Page_Heading}>
                      {data?.data?.attributes?.Page_Heading}
                    </h3>
                    {
                      <BlocksRenderer
                        content={data?.data?.attributes?.Body || []}
                      />
                    }
                  </div>
                </div>
              </div>
              <div className="col-lg-3 pl-20 md-pl-14">
                <div className="about-intro">
                  <QuickLinks />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <Accredation /> */}

      <Footer
        footerClass="rs-footer home9-style main-home"
        footerLogo={footerLogo}
      />

      {/* scrolltop-start */}
      <ScrollToTop scrollClassName="scrollup secondaryColor" />
      {/* scrolltop-end */}

      <SearchModal />
    </React.Fragment>
  );
};

export default ProjectOpportunities;
